import React from 'react'
import styleAboutPeriods from './CSS/styleAboutPeriods.css'
import Preg1 from "./images/Preg1.jpg";
import Preg2 from "./images/Preg2.jpg";

export default function About_PregLoss() {
    return (
        <div>
            <section id="overview">
                <h1 class="heading_big">Early and Recurrent Pregnancy Loss</h1>
                <h3 class="heading_content">PCOS Pregnancy Loss</h3>
                <p class="content">PCOS has numerous reproductive repercussions starting with anovulatory cycles leading to lesser chances of conceiving and even loss of fertility. Even after a successful conception, there are high chances of PCOS pregnancy loss, which is also known as the early loss of pregnancy (EPL). To add to it, if the woman with PCOS passes her third trimester, she may have to encounter later pregnancy complications like gestational diabetes mellitus (GDM).</p>

<h3 class="heading_content">Why polycystic ovarian syndrome pregnancy lead to the Risk of Early Pregnancy Loss?</h3>
<p class="content">Women with polycystic ovarian syndrome pregnancy symptoms are at risk of EPL. It is clinically tested that a first-trimester miscarriage can occur in 50% of pregnant women with PCOS, a rate which is three times higher than that in women without PCOS. Treatment of polycystic ovarian syndrome pregnancy with ovulation-induction agents is linked with higher rates of EPL compared to those in naturally conceiving women.

</p>

<img
    src={Preg1}
    class="img_overview"
/>

<h3 class="heading_content">Luteinizing Hormone and PCOS Pregnancy Loss at an early stage</h3>
<p class="content">Several studies have linked elevated LH levels with EPL in women with PCOS. The chances of miscarriage increase when the level of LH is elevated, and the conception rate decreased in those with normal LH in PCOS women.</p>

<h3 class="heading_content">Androgens and Early PCOS pregnancy loss</h3>
<p class="content">Hyperandrogenemia is a conceivable cause of EPL in women PCOS. The presence of hyperandrogenemia or clinical hyperandrogenism is considered to be definitive for PCOS diagnosis. Elevated free/total testosterone ratios are tested to be predictive of EPL in women with PCOS, with the help of two different studies.</p>

<h3 class="heading_content">Polycystic Ovarian Syndrome Recurrent Miscarriage</h3>
<p class="content">Polycystic Ovarian Syndrome Recurrent Miscarriage or recurrent pregnancy loss (RPL), defined as two or more consecutive pregnancy losses before the 20th week of pregnancy, is a frequently encountered adverse event in patients suffering from this syndrome.

It is important to remember there is no permanent cure for PCOS. The Polycystic Ovarian Syndrome pregnancy symptoms can only be controlled and managed on the bases of the treatment goals. For e.g., if you want to get pregnant, the doctor will regularly treat you with ovulation-inducing agents to improve your chances of getting pregnant and help you with a solution to Polycystic Ovarian Syndrome Recurrent Miscarriage

</p>

<img
    src={Preg2}
    class="img_overview"
/>

            </section>
        </div>
    )
}